// Template195: Bangkok - Lumphini Park (Día 3). Idéntico a PageLumphini.jsx. borderRadius: "12px".

import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { useMapFullscreen } from "../../context/MapFullscreenContext";

const Template195 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const [mapLoaded, setMapLoaded] = useState(false);
	const [fullscreen, setFullscreen] = useState(false);
	const { setMapFullscreen } = useMapFullscreen() || {};

	const headerText = page?.texts?.[0]?.content ?? "Día 3: Lumphini Park";
	const blockTitle = page?.texts?.[1]?.content ?? "Lumphini Park";
	const blockBody = page?.texts?.[2]?.content;
	const mapEmbedUrl = page?.data?.mapEmbedUrl;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const lumphiniImage = getImageSrc("lumphini");
	const stickerUrl = getCanvasImageUrl("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const actualHeaderColor = headerBackgroundColor || "#E8A838";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: "0 0 4px 0",
	};
	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#444",
		margin: 0,
	};

	useEffect(() => {
		const style = document.createElement("style");
		style.innerHTML = `@keyframes template195-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`;
		document.head.appendChild(style);
		return () => document.head.removeChild(style);
	}, []);

	useEffect(() => {
		if (typeof setMapFullscreen === "function") {
			setMapFullscreen(fullscreen);
			return () => setMapFullscreen(false);
		}
	}, [fullscreen, setMapFullscreen]);

	if (fullscreen && mapEmbedUrl) {
		return (
			<Box sx={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "#fff", zIndex: 9999, display: "flex", flexDirection: "column" }}>
				<Box sx={{ padding: "10px", textAlign: "right", backgroundColor: actualHeaderColor }}>
					<Box component="button" onClick={() => setFullscreen(false)} sx={{ backgroundColor: "#fff", color: actualHeaderColor, border: "none", borderRadius: "8px", padding: "6px 12px", fontWeight: 600, cursor: "pointer" }}>
						← Volver a la guía
					</Box>
				</Box>
				<Box component="iframe" title="Mapa grande Lumphini" src={mapEmbedUrl} width="100%" sx={{ border: 0, flex: 1 }} allowFullScreen loading="lazy" />
			</Box>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": { fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important` },
			}}
		>
			<Box data-block-id="header" data-template-header sx={{ backgroundColor: actualHeaderColor, color: headerTextColor || "#fff", textAlign: "center", padding: "15px 0", fontSize: "14px", fontWeight: 600, flexShrink: 0, position: "sticky", top: 0, zIndex: 1 }}>
				{headerText}
				{logoImage && <Box component="img" src={logoImage} alt="" sx={{ width: isSmallScreen ? 66 : 80, position: "absolute", right: 2, top: 18, zIndex: 999999 }} />}
			</Box>

			<Box data-block-id="map" sx={{ flex: 1, minHeight: 400, marginTop: "-70px", position: "relative", display: "flex", flexDirection: "column" }}>
				{stickerUrl && <Box component="img" src={stickerUrl} alt="" sx={{ width: 90, position: "absolute", bottom: -10, left: 0 }} />}
				{mapEmbedUrl && !mapLoaded && (
					<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1 }}>
						<Box sx={{ width: 20, height: 20, border: "4px solid #ccc", borderTop: "4px solid #E8A838", borderRadius: "50%", animation: "template195-spin 1s linear infinite" }} />
					</Box>
				)}
				{mapEmbedUrl ? (
					<>
						<Box component="button" onClick={() => setFullscreen(true)} sx={{ position: "absolute", top: 80, right: 10, backgroundColor: actualHeaderColor, color: "#fff", padding: "8px 10px", fontSize: "11px", borderRadius: "8px", boxShadow: "1px 1px 2px rgba(0,0,0,0.2)", zIndex: 4, border: "none", cursor: "pointer" }}>
							Ver mapa grande
						</Box>
						<Box component="iframe" title="Mapa Lumphini Park" src={mapEmbedUrl} loading="lazy" sx={{ border: 0, flex: 1, minHeight: 400, width: "100%" }} onLoad={() => setMapLoaded(true)} />
					</>
				) : (
					lumphiniImage && (
						<Box component="img" src={lumphiniImage} alt="" sx={{ width: "100%", height: "100%", minHeight: 400, objectFit: "cover", flex: 1 }} />
					)
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "0 12px", marginBottom: 1.75, marginTop: 1.75 }}>
				<Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
					{lumphiniImage && (
						<Box component="img" src={lumphiniImage} alt="" sx={{ width: "40%", height: 100, borderRadius: "12px", objectFit: "cover" }} />
					)}
					<Box sx={{ width: "60%", position: "relative" }}>
						<Box component="h3" sx={h3}>{blockTitle}</Box>
						{blockBody && <Box component="p" sx={p}>{blockBody}</Box>}
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

Template195.thumbnail = "/images/template-1.png";
export default Template195;
